/**
 * Delete a cookie
 */
import Cookies from "js-cookie";

import { getCookiesDomain } from "./getCookiesDomain";

const deleteCookie = (label: string): void => {
  const domain = getCookiesDomain();
  Cookies.remove(label, { domain });
};

export default deleteCookie;
